export const AT_SET_CARD_COLORS_SHOW_EDIT_TOOLTIP = 'CARD_COLORS_SHOW_EDIT_TOOLTIP_SET';
